import { MonitorSmartphone, Moon, Sun } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ROTULO_TEMA, useTema } from './TemaContext';

/**
 * Alternador de tema do cabeçalho.
 *
 * Um clique passa para o próximo modo (claro → escuro → automático). O ícone
 * mostra o que está valendo agora: sol no claro, lua no escuro e o aparelho
 * quando quem manda é o sistema.
 */
export function BotaoTema({ className }: { className?: string }) {
  const { tema, resolvido, alternar } = useTema();

  const Icone = tema === 'sistema' ? MonitorSmartphone : resolvido === 'escuro' ? Moon : Sun;
  const proximo = tema === 'claro' ? 'escuro' : tema === 'escuro' ? 'sistema' : 'claro';

  return (
    <Button
      variant="fantasma"
      tamanho="icone"
      onClick={alternar}
      className={className}
      title={`Tema: ${ROTULO_TEMA[tema]} · clique para ${ROTULO_TEMA[proximo].toLowerCase()}`}
      aria-label={`Tema ${ROTULO_TEMA[tema]}. Mudar para ${ROTULO_TEMA[proximo]}.`}
    >
      <Icone />
    </Button>
  );
}
